import { render, staticRenderFns } from "./PhysicalActivityForm.vue?vue&type=template&id=13614cef&"
import script from "./PhysicalActivityForm.vue?vue&type=script&lang=js&"
export * from "./PhysicalActivityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports